﻿import React, {JSX} from "react";
import MaterialIcon from "../MaterialIcon";
import {HtmlRequiredPrefixedControlProps} from "./HtmlControlProps";
import LabeledControl from "./LabeledControl";
import {useLabeledControl} from "./LabeledControlData";

export type FileInputProps = Omit<HtmlRequiredPrefixedControlProps<HTMLInputElement>, "value"> & {
	value?: FileList | null | undefined;
	multiple?: boolean;
	accept?: string;
	capture?: "user" | "environment" | undefined;

}

function getFileIcon(fileType: string): string {
	if (fileType.includes("pdf")) return "picture_as_pdf";
	if (fileType.includes("jpg") || fileType.includes("jpeg") || fileType.includes("png")) return "photo_library";
	return "content_copy";
}

function isEmptyFileList(fileList?: FileList | null): fileList is null | undefined {
	return fileList == null || fileList.length === 0;
}

export default function FileInput(props: FileInputProps): JSX.Element {
	const {
		id,
		label,
		hint,
		column,
		controlPrefix,
		controlSuffix,
		name,
		value,
		hidden,
		onChange,
		onBlur,
		error,
		required,
		disabled,
		ref,
		multiple,
		accept,
		capture
	} = props;

	const {componentId, ariaRef} = useLabeledControl(id);

	if (hidden) {
		return <></>;
	}

	return (
		<LabeledControl label={label} type="file" id={componentId} required={required} column={column} error={error}
		                hint={hint} hidden={hidden} ariaRef={ariaRef} controlPrefix={controlPrefix}
		                controlSuffix={controlSuffix}>
			<input
				id={componentId}
				type="file"
				ref={ref}
				onChange={onChange}
				onBlur={onBlur}
				name={name}
				required={required}
				aria-describedby={ariaRef.current?.describedBy}
				aria-invalid={ariaRef.current?.invalid}
				aria-required={required}
				readOnly={disabled}
				tabIndex={disabled ? -1 : undefined}
				multiple={multiple}
				accept={accept}
				capture={capture}/>

			<span className="field__input__file-list">{
				isEmptyFileList(value)
					? <span className="field__input__file-list--choose">
						<MaterialIcon icon="cloud_upload"/>
						<span>{multiple ? "Select/drop one or more files" : "Choose/drop a file"}
						</span>
				</span>
					: <span className="field__input__file-list--files">
						{Array.from(value).map((item: File, index: number) => (
							<span key={index}>
								<MaterialIcon icon={getFileIcon(item.type)}/>
								{item.name}
							</span>)
						)}
					</span>
			}</span>
		</LabeledControl>
	);
}
